import React from 'react';
import { CalculatorIcon } from 'lucide-react';
import { primaryVolumes, secondaryVolumes, Volume } from '../data/content';
type VolumeGroupProps = {
  title: string;
  subtitle: string;
  volumes: Volume[];
};
function VolumeGroup({
  title,
  subtitle,
  volumes
}: VolumeGroupProps) {
  return <div data-id="element-222" data-mp="put2vc94esg4">
      <div className="flex items-baseline gap-3" data-id="element-223" data-mp="pujbbk8fgd8b">
        <h3 className="font-display text-xl font-black tracking-tight text-foreground" data-id="element-224" data-mp="pxf9n9o6t3xa">
          {title}
        </h3>
        <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-secondary" data-id="element-225" data-mp="fx4wfp25jwi4">
          {subtitle}
        </span>
      </div>
      <ul className="mt-5 space-y-3" data-id="element-226" data-mp="26t1zji3hlnt">
        {volumes.map(volume => <li key={volume.grade} className="rounded-2xl bg-background px-5 py-4" data-id="element-227" data-mp="74l5las3qw7u">
            <span className="inline-block rounded-full bg-inverse px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-surface" data-id="element-228" data-mp="72gpzvkuc8rq">
              {volume.grade}
            </span>
            <h4 className="mt-2.5 font-display text-base font-bold text-foreground" data-id="element-229" data-mp="3te5jjzmw4149">
              {volume.title}
            </h4>
            <p className="mt-1 text-xs leading-relaxed text-foreground/55" data-id="element-230" data-mp="37v325wpo0sjf">
              {volume.text}
            </p>
          </li>)}
      </ul>
    </div>;
}
export function WhatsInside() {
  return <section id="contenuto" className="w-full bg-surface px-5 py-20 sm:py-28" data-id="element-231" data-mp="3hta6ng2rpi4j">
      <div className="mx-auto max-w-4xl" data-id="element-232" data-mp="3hr64p3ofit6w">
        <div className="text-center" data-id="element-233" data-mp="2u2myqusuqshz">
          <span className="eyebrow-rule text-[11px] font-bold uppercase tracking-[0.22em] text-secondary" data-id="element-234" data-mp="2u3o7gsmeb2wj">
            8 volumi digitali · PDF ad alta risoluzione
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-foreground sm:text-[2.4rem]" data-id="element-235" data-mp="32wjg7wb2ngr2">
            <CalculatorIcon className="mb-1.5 mr-2 inline-block h-7 w-7 text-primary sm:h-8 sm:w-8" aria-hidden="true" data-id="element-236" data-mp="2y36srpi4pfzw" />
            Cosa trovi dentro il pack{' '}
            <span className="italic text-primary" data-id="element-237" data-mp="26d2dg5987j5j">Matematica Pronta?</span>
          </h2>
        </div>

        <div className="mt-12 grid gap-10 md:grid-cols-2" data-id="element-238" data-mp="9coe53h4hiiy">
          <VolumeGroup title="Percorso Scuola Primaria" subtitle="5 volumi" volumes={primaryVolumes} data-id="element-239" data-mp="ebslrpoef876" />
          <VolumeGroup title="Percorso Scuola Media" subtitle="3 volumi" volumes={secondaryVolumes} data-id="element-240" data-mp="j2het9fq8d8f" />
        </div>
      </div>
    </section>;
}